export default __webpack_public_path__ + "static/media/close-btn.830a9b6d.svg";